import { C } from '../../lib/tokens.js';

export function PageShell({ title, subtitle, actions, children }) {
  return (
    <div style={{ flex: 1, overflow: 'auto', background: C.platinum }}>
      <div style={{ background: C.tin, borderBottom: `1px solid ${C.mercury}`, padding: '20px 24px', display: 'flex', alignItems: 'flex-start', gap: 16, flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 200px' }}>
          <h1 style={{ margin: 0, fontFamily: 'Roboto', fontWeight: 300, fontSize: 26, color: C.deepsea }}>{title}</h1>
          {subtitle ? <div style={{ fontSize: 13, color: C.iron, marginTop: 4 }}>{subtitle}</div> : null}
        </div>
        {actions ? <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>{actions}</div> : null}
      </div>
      <div style={{ padding: 24 }}>{children}</div>
    </div>
  );
}
